/*
 * Murals — Request list (quote list)
 * ------------------------------------------------------------------
 * Client-side, no backend: accumulates products the user wants info /
 * a quote on in localStorage, then submits them all as ONE native
 * Shopify contact-form lead.
 *
 * Item shape:
 *   { id, marca, product, url, pattern, supporto, larghezza, altezza, area, porzione,
 *     thumb, ref_w, ref_h }
 *   Or.nami: + { ornami:true, autore, modulo, materiale } — larghezza/altezza/area/
 *   porzione solo se il cliente ha ritagliato. `pattern` ripete l'autore per i
 *   lettori della forma precedente. ref_w/ref_h sono i cm che l'immagine del
 *   ritaglio rappresenta (Murals 472x300, Or.nami il modulo): il backend ne ha
 *   bisogno per ritagliare l'anteprima nel punto giusto (2026-10-07).
 *
 * Public API (window.MuralsRequest):
 *   add(item) · addFromConfigurator(btn) · remove(id) · all() · count() · clear() · render()
 */
(function () {
  var STORE_KEY = 'murals_request_list';

  function read() {
    try {
      var raw = window.localStorage.getItem(STORE_KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch (e) {
      return [];
    }
  }

  function write(arr) {
    try {
      window.localStorage.setItem(STORE_KEY, JSON.stringify(arr));
    } catch (e) {}
    render();
    try { document.dispatchEvent(new CustomEvent('murals:request:change')); } catch (e) {}
  }

  function all() { return read(); }
  function count() { return read().length; }

  // GA4 (via Customer Events sandbox). Guarded — tracking is optional.
  function mtrack(name, params) {
    if (window.MuralsTracking && typeof window.MuralsTracking.track === 'function') {
      window.MuralsTracking.track(name, params || {});
    }
  }
  function handleOf(url) {
    if (!url) return '';
    var m = String(url).split('?')[0].replace(/\/$/, '').split('/');
    return m[m.length - 1] || '';
  }

  function add(item) {
    if (!item) return;
    var arr = read();
    item.id = item.id || String(Date.now()) + '-' + arr.length;
    arr.push(item);
    write(arr);
    toast(t('added', 'Aggiunto alla richiesta'));
  }

  function remove(id) {
    write(read().filter(function (it) { return String(it.id) !== String(id); }));
    mtrack('remove_from_request', { items_count: count() });
  }

  function clear() { write([]); }

  // --- Read the configurator state on the current PDP -----------------------
  function val(sel)  { var el = document.querySelector(sel); return el ? (el.value || '') : ''; }
  function txt(sel)  { var el = document.querySelector(sel); return el ? (el.textContent || '').trim() : ''; }
  function attr(sel, a) { var el = document.querySelector(sel); return el ? (el.getAttribute(a) || '') : ''; }

  /*
    L'AGGIUNTA DAL CATALOGO OR.NAMI.

    I campi di catalogo (codice, autore, modulo) arrivano dal bottone, che li ha
    dal prodotto - e dal 2026-09-11 il bottone li cambia quando si sceglie
    un'altra colorazione nel configuratore.

    Dal 2026-09-11 la scheda Or.nami monta anche il configuratore di ritaglio,
    con i parametri suoi (modulo 87x87, telo 50). Se il cliente ha ritagliato,
    la richiesta porta ANCHE la porzione, letta con `leggiRitaglio` - la stessa
    lettura di `addFromConfigurator`, nello stesso formato. Se non ha
    ritagliato, la richiesta parte lo stesso con i soli dati di catalogo: qui
    NON si ripiega sull'«intera grafica», perche' un modulo non e' una parete e
    87x87 non sarebbe una scelta del cliente ma un dato inventato.
  */
  /*
    IL RISCONTRO STA SUL BOTTONE, non solo nel toast.

    Il toast vive in fondo alla finestra - misurato 858-892px su un viewport
    da 900 - cioe' esattamente dove siede il banner dei cookie: alla prima
    visita `elementFromPoint` al centro del toast restituisce il banner, quindi
    l'unico riscontro dell'azione principale e' coperto. Alzarlo sopra un
    banner di consenso non e' una strada percorribile: quel banner deve
    restare il primo piano finche' non ha risposta.

    Il riscontro va dove avviene l'azione. Il bottone stesso dice cosa e'
    successo, e nessun altro elemento gli puo' finire sopra.

    E non si aggiunge due volte lo stesso disegno: prima erano tre clic, tre
    righe identiche e nessun modo di accorgersene. Ora il secondo clic lo dice
    invece di rifarlo - la lista e' una richiesta, non un carrello dove la
    quantita' ha senso.

    MA SE LA PORZIONE E' CAMBIATA, LA RIGA SI AGGIORNA (2026-09-11). «Gia'
    nella richiesta» suonava come una conferma mentre buttava via il ritaglio
    appena tracciato; ora la riga per lo stesso URL viene riscritta e il
    bottone dice «Porzione aggiornata nella richiesta». «Gia' nella
    richiesta» resta solo quando i dati sono davvero identici.

    E DOPO «AGGIUNTO» C'E' IL PASSO DOPO. Il bottone resta in stato
    «Aggiunto · Vedi la richiesta (n)» e un clic apre il cassetto, come fa
    Murals con `addFromConfigurator`; torna «Aggiungi…» appena il ritaglio o
    la colorazione cambiano (evento `murals:configurator:update`), perche' a
    quel punto c'e' di nuovo qualcosa da aggiungere.
  */
  /*
    LA LARGHEZZA SI FISSA AL CARICAMENTO, non al primo clic.

    Va presa sulla PIU' LARGA delle tre etichette che il bottone puo' mostrare:
    "Aggiunto" e' piu' lungo di "Aggiungi", quindi congelandola su quella di
    partenza il bottone cresceva comunque - misurato 319 -> 325. E farlo al
    primo clic non basta: a quel punto il bottone ha gia' reso alla larghezza
    corta, e il salto si vede lo stesso. Tre misure una volta sola, prima che
    qualcuno tocchi niente.
  */
  function fissaLarghezza(btn) {
    if (!btn || btn.dataset.larghezzaFissata) return;
    var originale = btn.dataset.etichettaOriginale || (btn.textContent || '').trim();
    btn.dataset.etichettaOriginale = originale;
    var etichette = [originale,
                     t('added_short', 'Aggiunto alla richiesta'),
                     t('already_in_request', 'Già nella richiesta'),
                     t('updated_in_request', 'Porzione aggiornata nella richiesta'),
                     etichettaVedi(99)];
    var massimo = 0;
    for (var k = 0; k < etichette.length; k++) {
      btn.textContent = etichette[k];
      var w = btn.getBoundingClientRect().width;
      if (w > massimo) massimo = w;
    }
    btn.textContent = originale;
    btn.style.minWidth = Math.ceil(massimo) + 'px';
    btn.dataset.larghezzaFissata = '1';
  }

  function etichettaVedi(n) {
    return t('added_see', 'Aggiunto · Vedi la richiesta') + ' (' + n + ') →';
  }

  function ripristinaBottone(btn) {
    if (!btn) return;
    if (btn.__timerSegnale) clearTimeout(btn.__timerSegnale);
    btn.__timerSegnale = null;
    if (btn.dataset.etichettaOriginale) btn.textContent = btn.dataset.etichettaOriginale;
    btn.classList.remove('is-segnalato');
    btn.classList.remove('is-aggiunto');
  }

  // `poi`: cosa mostrare quando il segnale temporaneo finisce. Di norma
  // l'etichetta di partenza; dopo un'aggiunta, il passo successivo.
  function segnalaSulBottone(btn, testo, poi) {
    if (!btn) return;
    if (!btn.dataset.etichettaOriginale) {
      btn.dataset.etichettaOriginale = (btn.textContent || '').trim();
    }
    fissaLarghezza(btn);
    btn.textContent = testo;
    btn.classList.add('is-segnalato');
    btn.classList.remove('is-aggiunto');
    if (btn.__timerSegnale) clearTimeout(btn.__timerSegnale);
    btn.__timerSegnale = setTimeout(function () {
      btn.classList.remove('is-segnalato');
      if (typeof poi === 'function') { poi(btn); return; }
      btn.textContent = btn.dataset.etichettaOriginale;
    }, 2600);
  }

  // Lo stato «Aggiunto · Vedi la richiesta (n)»: persiste finche' il ritaglio
  // non cambia, e il clic apre il cassetto invece di aggiungere di nuovo.
  function mostraVedi(btn) {
    if (!btn) return;
    btn.textContent = etichettaVedi(count());
    btn.classList.add('is-aggiunto');
  }

  function ripristinaTuttiIBottoni() {
    var ctas = document.querySelectorAll('.ornami-product__cta.is-aggiunto, .ornami-product__cta.is-segnalato');
    for (var i = 0; i < ctas.length; i++) ripristinaBottone(ctas[i]);
  }

  // Lo stato del ritaglio sul PDP corrente, per entrambe le marche. `presente`
  // e' falso quando il cliente non ha ancora tracciato niente.
  function leggiRitaglio() {
    // Configuratore assente (Jcrop non arrivato): i campi sono disabilitati e
    // NON descrivono una porzione, qualunque cosa contengano.
    if (document.querySelector('.product-config.is-non-disponibile')) {
      return { presente: false, larghezza: '', altezza: '', area: '', porzione: '' };
    }
    var w = val('.product-config .sizes .w .num');
    var h = val('.product-config .sizes .h .num');
    return {
      presente:  !!w && parseFloat(w) > 0 && !!h && parseFloat(h) > 0,
      larghezza: w,
      altezza:   val('.product-config .sizes .h .num'),
      area:      txt('.product-config .sizes .tot .num'),
      porzione:  val('#config-parameters')
    };
  }

  function stessaPorzione(a, b) {
    var campi = ['product', 'pattern', 'modulo', 'supporto', 'larghezza', 'altezza', 'area', 'porzione'];
    for (var i = 0; i < campi.length; i++) {
      if (String(a[campi[i]] || '') !== String(b[campi[i]] || '')) return false;
    }
    return true;
  }

  function addOrnami(btn) {
    // Secondo clic sullo stato «Aggiunto · Vedi la richiesta»: apre il cassetto.
    if (btn && btn.classList.contains('is-aggiunto')) {
      if (typeof window.openRequestDrawer === 'function') window.openRequestDrawer();
      return;
    }

    var ds = (btn && btn.dataset) || {};
    var url = ds.productUrl || '';

    var item = {
      marca:     'ornami',
      ornami:    true,
      product:   ds.productTitle || '',
      url:       url,
      autore:    ds.autore || '',
      pattern:   ds.autore || '',
      modulo:    ds.modulo || '',
      materiale: ds.materiale || '',
      supporto:  attr('.product-config .product-type .variant-color.selected', 'data-value'),
      thumb:     ds.thumb || '',
      ref_w:     attr('.product-config', 'data-ref-w'),
      ref_h:     attr('.product-config', 'data-ref-h')
    };
    var r = leggiRitaglio();
    if (r.presente) {
      item.larghezza = r.larghezza;
      item.altezza   = r.altezza;
      item.area      = r.area;
      item.porzione  = r.porzione;
    }

    var arr = read();
    var idx = -1;
    for (var i = 0; i < arr.length; i++) {
      if (arr[i].ornami && arr[i].url && arr[i].url === url) { idx = i; break; }
    }

    if (idx >= 0) {
      if (stessaPorzione(arr[idx], item)) {
        segnalaSulBottone(btn, t('already_in_request', 'Già nella richiesta'), mostraVedi);
        return;
      }
      item.id = arr[idx].id;
      arr[idx] = item;
      write(arr);
      toast(t('updated_in_request', 'Porzione aggiornata nella richiesta'));
      segnalaSulBottone(btn, t('updated_in_request', 'Porzione aggiornata nella richiesta'), mostraVedi);
      mtrack('update_request', {
        item_id:   handleOf(item.url),
        item_name: item.product,
        brand:     'ornami',
        area_sqm:  parseFloat(item.area) || 0
      });
      return;
    }

    add(item);
    segnalaSulBottone(btn, t('added_short', 'Aggiunto alla richiesta'), mostraVedi);

    mtrack('add_to_request', {
      item_id:   handleOf(item.url),
      item_name: item.product,
      brand:     'ornami',
      area_sqm:  parseFloat(item.area) || 0,
      whole:     false
    });
  }

  function addFromConfigurator(btn) {
    var ds = (btn && btn.dataset) || {};
    var r = leggiRitaglio();
    var w = r.larghezza, h = r.altezza, area = r.area, porzione = r.porzione;
    var whole = false;

    // No crop selected → assume the WHOLE graphic at reference size.
    if (!r.presente) {
      var rw = window.refW || 472, rh = window.refH || 300;
      w = String(rw); h = String(rh);
      area = ((rw / 100) * (rh / 100)).toFixed(2);
      porzione = '';
      whole = true;
    }

    var item = {
      marca:     'murals',
      product:   ds.productTitle || '',
      url:       ds.productUrl || '',
      ref_w:     String(window.refW || 472),
      ref_h:     String(window.refH || 300),
      pattern:   val('.variant-box .select-option-1'),
      supporto:  attr('.product-config .product-type .variant-color.selected', 'data-value'),
      larghezza: w,
      altezza:   h,
      area:      area,
      porzione:  porzione,
      thumb:     attr('#config-pattern', 'src'),
      whole:     whole
    };
    add(item);

    mtrack('add_to_request', {
      item_id:      handleOf(item.url),
      item_name:    item.product,
      pattern_name: item.pattern,
      support_type: item.supporto,
      area_sqm:     parseFloat(item.area) || 0,
      whole:        !!item.whole
    });

    // Open the drawer so the user sees their list build up.
    if (typeof window.openRequestDrawer === 'function') window.openRequestDrawer();
  }

  // --- Rendering ------------------------------------------------------------
  function dimsOf(it) {
    var dims = '';
    if (it.larghezza && parseFloat(it.larghezza) > 0) {
      dims = it.larghezza + ' × ' + it.altezza + ' cm';
      if (it.area) dims += ' · ' + it.area + ' m²';
    }
    return dims;
  }

  function sizeLabel(it) {
    // Or.nami cataloga un disegno identificato da un codice e da un modulo
    // fisso: senza ritaglio la riga dice il modulo, non "Porzione da
    // definire". Con il ritaglio dice la porzione e poi il modulo. Il ramo e'
    // additivo: gli elementi Murals non portano mai `ornami`.
    var dims = dimsOf(it);
    if (it.ornami) {
      var mod = it.modulo ? 'modulo ' + it.modulo : '';
      if (dims && mod) return dims + ' · ' + mod;
      return dims || it.modulo || '';
    }
    if (it.whole) return t('whole_graphic', 'Intera grafica') + (dims ? ' · ' + dims : '');
    return dims || t('undefined_portion', 'Porzione da definire');
  }

  function buildRow(it) {
    var row = document.createElement('div');
    row.className = 'request-item';
    row.setAttribute('data-id', it.id);

    var thumb = document.createElement('div');
    thumb.className = 'request-item__thumb';
    if (it.thumb) {
      var img = document.createElement('img');
      img.src = it.thumb; img.width = 64; img.height = 64; img.alt = '';
      thumb.appendChild(img);
    }

    var meta = document.createElement('div');
    meta.className = 'request-item__meta fs-13';
    meta.appendChild(line(it.product, 'f-w-600'));
    if (it.pattern)  meta.appendChild(line(it.pattern, 'c-color-1'));
    if (it.supporto) meta.appendChild(line(it.supporto, 'c-color-1 t-u'));
    meta.appendChild(line(sizeLabel(it), ''));

    var rm = document.createElement('button');
    rm.type = 'button';
    rm.className = 'request-item__remove';
    rm.setAttribute('aria-label', t('remove', 'Rimuovi'));
    rm.setAttribute('data-remove', it.id);
    rm.innerHTML = '&times;';
    rm.addEventListener('click', function () { remove(it.id); });

    row.appendChild(thumb);
    row.appendChild(meta);
    row.appendChild(rm);
    return row;
  }

  function line(str, cls) {
    var d = document.createElement('div');
    if (cls) d.className = cls;
    d.textContent = str || '';
    return d;
  }

  function render() {
    var items = read();
    var n = items.length;

    // Header counter badge(s)
    var badges = document.querySelectorAll('[data-request-count]');
    Array.prototype.forEach.call(badges, function (b) {
      b.textContent = n;
      if (n > 0) b.removeAttribute('hidden'); else b.setAttribute('hidden', '');
    });
    var opener = document.getElementById('request-open');
    if (opener) opener.setAttribute('aria-label', t('request_list', 'Richiesta') + ' (' + n + ')');

    // Drawer list + empty state
    var listEl = document.getElementById('request-items');
    var emptyEl = document.getElementById('request-empty');
    if (listEl) {
      listEl.innerHTML = '';
      items.forEach(function (it) { listEl.appendChild(buildRow(it)); });
    }
    if (emptyEl) emptyEl.style.display = n === 0 ? '' : 'none';

    // Gate submit
    var form = document.getElementById('RequestInfoForm');
    if (form) {
      var submit = form.querySelector('button[type="submit"]');
      if (submit) {
        submit.disabled = n === 0;
        submit.classList.toggle('is-disabled', n === 0);
      }
    }
  }

  // --- Submit: inject one readable hidden field per product -----------------
  function injectFields(form) {
    if (!form) return;
    Array.prototype.forEach.call(
      form.querySelectorAll('[data-request-injected]'),
      function (el) { el.parentNode.removeChild(el); }
    );
    var items = read();
    items.forEach(function (it, i) {
      var parts = [it.product];
      if (it.pattern)  parts.push((it.ornami ? 'Autore: ' : 'Pattern: ') + it.pattern);
      if (it.supporto) parts.push('Supporto: ' + it.supporto);
      if (it.ornami) {
        parts.splice(1, 0, 'Marca: Or.nami');
        if (it.modulo)    parts.push('Modulo: ' + it.modulo);
        if (it.materiale) parts.push('Materiale: ' + it.materiale);
        if (dimsOf(it))   parts.push('Dimensioni: ' + dimsOf(it));
      } else {
        parts.push('Dimensioni: ' + sizeLabel(it));
      }
      if (it.porzione) parts.push('Porzione: ' + it.porzione);
      if (it.url)      parts.push(it.url);
      inject(form, 'contact[Prodotto ' + (i + 1) + ']', parts.join(' · '));
    });
    inject(form, 'contact[N prodotti]', String(items.length));
  }

  function inject(form, name, value) {
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    input.setAttribute('data-request-injected', '');
    form.appendChild(input);
  }

  // --- Toast ----------------------------------------------------------------
  var toastTimer = null;
  function toast(msg) {
    var el = document.getElementById('murals-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'murals-toast';
      el.className = 'murals-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.textContent = msg;
    el.classList.add('show');
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('show'); }, 2600);
  }

  // --- i18n (labels injected on window by the drawer snippet) ---------------
  function t(key, fallback) {
    return (window.MuralsRequestStrings && window.MuralsRequestStrings[key]) || fallback;
  }

  // --- Wire up --------------------------------------------------------------
  window.MuralsRequest = {
    add: add, addFromConfigurator: addFromConfigurator, addOrnami: addOrnami, remove: remove,
    all: all, count: count, clear: clear, render: render, injectFields: injectFields
  };

  function init() {
    render();
    // I bottoni Or.nami prendono la loro larghezza definitiva prima di essere
    // toccati: vedi `fissaLarghezza`.
    // Solo i bottoni veri: sulla scheda c'e' anche un'ancora con la stessa
    // classe che porta al configuratore, senza data-* e senza etichetta da
    // fissare.
    var ctas = document.querySelectorAll('.ornami-product__cta[data-product-url]');
    for (var i = 0; i < ctas.length; i++) { fissaLarghezza(ctas[i]); }
    // Cross-tab sync.
    window.addEventListener('storage', function (e) { if (e.key === STORE_KEY) render(); });
    // Il ritaglio o la colorazione cambiano: il bottone torna «Aggiungi…».
    document.addEventListener('murals:configurator:update', ripristinaTuttiIBottoni);
    // Il conteggio nello stato «Vedi la richiesta (n)» segue la lista.
    // Se la riga viene tolta dal cassetto, il bottone torna «Aggiungi…».
    document.addEventListener('murals:request:change', function () {
      var ctas = document.querySelectorAll('.ornami-product__cta.is-aggiunto');
      var lista = read();
      for (var i = 0; i < ctas.length; i++) {
        var url = ctas[i].dataset.productUrl || '';
        var c = false;
        for (var k = 0; k < lista.length; k++) { if (lista[k].url === url) { c = true; break; } }
        if (c) ctas[i].textContent = etichettaVedi(lista.length); else ripristinaBottone(ctas[i]);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
